<template>
  <div>
    <div class="p-24 pointer" v-if="!show_task_edit">
      <div @click="addTask(true)">
        <span class="text-large mr-16">+</span><span class="text-large">Add task for this project</span>
      </div>
    </div>
    <div v-if="show_task_edit && project" class="p-24">
      <table class="w-100">
        <tr>
          <td class="w-70 p-8 pl-0 heading-medium">Tasks for {{ project.name }}</td>
          <td class="pl-8">
            <v-select
              v-if="templates"
              :disabled="!templates"
              v-model="selected_template"
              :options="templates"
              label="name"
              :reduce="c => c.id"
              @blur="$v.selected_template.$touch()"
            ></v-select>
          </td><td>
          </td>
        </tr>
        <tr>
          <td class="text-strong p-8 pl-0 pb-0">Task name</td>
          <td class="text-strong p-8 pb-0">Planned hours</td>
          <td></td>
        </tr>
        <tr v-for="task in tasks">
          <td class="w-70 p-8 pl-0">
            <input v-model="task.name" type="text" class="form-control" placeholder="Task name...">
          </td>
          <td class="p-8">
            <input v-model="task.duration" type="text" class="form-control" placeholder="Planned hours...">
          </td>
          <td>
            <div @click="removeTask(task)">
              <svg-trash-can></svg-trash-can>
            </div>
          </td>
        </tr>
        <tr>
          <td class="w-70 p-8 pl-0">
            <span class="pointer" @click="addTask()">+ Add another task</span>
          </td>
          <td class="text-right p-8">
            Total: {{ _total_hours }}
          </td>
        </tr>
        <tr>
          <td class="w-70 p-8 pl-0">
            <div class="flex align-items-center">
              <input type="checkbox" v-model="save_as_template">
              <span class="ml-2">Save these tasks as a template</span>
            </div>
          </td>
          <td class="text-right p-8">
            <input v-show="save_as_template" v-model="template_name" type="text" class="form-control" placeholder="Template name">
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
let newTask = {
  name: null,
  duration: '01:00',
}
export default {
  props: {
    project: {},
    value: {},
  },
  created() {
    this.loadTemplates()
    this.$root.$on('TaskDetailsEdit::reset', () => {
      this.reset()
    })
  },
  data() {
    return {
      tasks: [],
      show_task_edit: false,
      save_as_template: null,
      template_name: null,
      templates: null,
      selected_template: null,
    }
  },
  computed: {
    _total_hours() {
      let integerSeconds = _.map(this.tasks, task => {
        return this.$root.formatTimestringToIntegerSeconds(task.duration)
      })
      integerSeconds = _.sum(integerSeconds)

      return this.$root.secondsToTimestring(integerSeconds)
    }
  },
  watch: {
    tasks: {
      handler(value) {
        if (value.length === 0) {
          this.$root.$emit('TaskDetailsEdit::removedAllTasks')
          this.reset(true)
        }
        this.emitTaskData()
      },
      deep: true,
    },
    template_name: {
      handler() {
        this.emitTaskData()
      }
    },
    show_task_edit(value) {
      if (value) {
        this.loadTemplates()
      }
    },
    selected_template(value) {
      if (value == null) {
        return;
      }
      if (value) {
        this.selectTemplate(value)
      }
      this.selected_template = null
    }
  },
  methods: {
    loadTemplates() {
      this.axios.get('/n/task-templates').then(response => {
        this.templates = response.data.data
      })
    },
    addTask(first = false) {
      if (!this.project) return

      this.show_task_edit = true

      let task = _.clone(newTask)
      task.id = _.uniqueId()
      this.tasks.push(task)

      if (first) {
        this.$root.$emit('TaskDetailsEdit::addedFirstTask')
      }
    },
    removeTask(task) {
      this.tasks = _.reject(this.tasks, t => t.id === task.id)
    },
    reset(withoutTasks = false) {
      if (!withoutTasks) {
        this.tasks = []
      }
      this.save_as_template = false
      this.template_name = null
      this.show_task_edit = false
      this.selected_template = null
    },
    emitTaskData() {
      this.$emit('input', {
        tasks: this.tasks,
        template_name: this.template_name,
      });
    },
    selectTemplate(template) {
      this.tasks = []
      _.each(template.template, task => {
        this.tasks.push(task)
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/project-modal/task-details-edit.vue